export const faqs = [
  {
    q: "What is Aura Events?",
    a: "Aura Events is a curated events and experiences brand creating meaningful gatherings across lifestyle, wellness, technology, business, creativity, learning, community, and culture.",
  },
  {
    q: "Is Aura only for wellness events?",
    a: "No. Aura is launching with lifestyle and wellness experiences, but the brand is designed to grow into multiple event tracks including tech, business, learning, creative, and community events.",
  },
  {
    q: "Who can attend Aura events?",
    a: "Aura events are designed for professionals, teams, founders, creators, learners, communities, and anyone interested in curated, high-value experiences.",
  },
  {
    q: "Can companies book Aura events?",
    a: "Yes. Aura can design private events for companies, HR teams, offsites, employee engagement days, wellness programs, learning sessions, and team-building formats.",
  },
  {
    q: "Can I collaborate with Aura?",
    a: "Yes. Aura can collaborate with speakers, facilitators, venues, brands, experts, communities, and sponsors.",
  },
  {
    q: "Are wellness sessions medical advice?",
    a: "No. Wellness events provide general lifestyle education and practical support. They do not diagnose, treat, cure, or replace medical advice from qualified healthcare professionals.",
  },
  {
    q: "Will Aura host tech events?",
    a: "Yes. Technology, AI, startup, product, and future-of-work events are planned as future Aura tracks.",
  },
];
